import { calculateVincentyDistance, getSortedTowLog, type ITowLogEvent } from '../../tow-log';
import type { ICprMathContext } from '../interface/cpr-math-context.interface';

/**
 * Calculates the total distance where the tow was in the water using Vinenty's formulae.
 *
 * @param towLog The complete tow log. It can be unordered.
 */
export const calculateTowedMiles = (towLog: ITowLogEvent<unknown, string | Date>[]): number =>
  getSortedTowLog(towLog).reduce((sum, event, i, arr) => {
    if (i == 0 || event.eventCode === 'MIDSHOOT') {
      return sum;
    } else {
      return sum + calculateVincentyDistance(arr[i - 1]!, event);
    }
  }, 0);

/**
 * Gets the total distance where the tow was in the water using Vinenty's formulae.
 *
 * @returns The pre-calculated value from tow metadata if available, otherwise calculates it from
 *   the tow log if available. If neither method is available, returns `null`.
 */
export const getTowedMiles = ({ towLog, tow }: ICprMathContext<unknown>): number | null =>
  tow?.towMileage ?? (towLog?.length ? calculateTowedMiles(towLog) : null);
